import { Injectable } from '@angular/core';
import { RxState } from '@rx-angular/state';

import { NotificationsState } from './notifications.state';

@Injectable()
export class NotificationsStore extends RxState<NotificationsState> {

    constructor() {
        super();
        this.resetState();
    }

    resetState(): void {
        this.set({
            items: [],
            unreadCount: 0,
            loading: false,
            loadingMore: false,
            hasMore: false,
            nextCursor: null,
            filterUnread: false,
            panelOpen: false,
        });
    }
}
